module.exports = {"371722001":"北城街道","371722002":"南城街道","371722003":"园艺街道","371722004":"东城街道","371722101":"郭村镇","371722102":"黄岗镇","371722103":"终兴镇","371722105":"高韦庄镇","371722106":"徐寨镇","371722107":"蔡堂镇","371722108":"朱集镇","371722109":"李新庄镇","371722110":"浮岗镇","371722111":"莱河镇","371722112":"时楼镇","371722113":"杨楼镇","371722114":"张集镇","371722115":"龙王庙镇","371722116":"谢集镇","371722117":"李田楼镇","371722201":"高老家乡","371722202":"曹庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371722.json
// module id = 1382
// module chunks = 0